/**
 * obiekt pojedycznej
 * Nazwa pliku jest jednocześnie numerem strony. Zalecany format to page001.js;page002.js itd.
 * Strona page000.js jest dodana dla zachowania poprawnego ukøadu w multibooku.
 * Każde id musi być unikalne w obrębie danego multibooka. Zalecany format id to dla page001.js : page_001_gallery1;page_001_film1;page_001_rect1 itd.
 *
 *
 * @param  {String} imageSrc    nazwa pliku tła wraz z relatywną ścieżką dostępu i rozszerzeniem  np.: background/testBackground.jpg *
 * @param  {Object[]} film      obiekt konfigurujący film na stronie
 * @param  {String} film[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} film[].id   id filmu
 * @param  {String} film[].icon   ikona filmu
 * @param  {Boolean} film[].dense   zmniejszona wielkosc ikon do 75% wartosci filmu
 * @param  {Object} film[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} film[].item   obiekt filmu
 * @param  {String} film[].item.title   tytuł filmu (pojawi się w belce odtwarzacza) tymaczasowe klasy title: '<div class="film-title-main">Mózg</div><div class="film-title-description" >Nowoczesne metody badania ludzkiego mózgu pozwalają na bezinwazyjne obserwacje funkcji poszczególnych części mózgu, bez konieczności wykonywania niebezpiecznych operacji chirurgicznych. Badania te pozwalają między innymi dokładnie zdiagnozować nowotwory układu nerwowego,  ocenić rodzaj uszkodzenia tkanek czy rozwój schorzeń takich jak np. choroba Alzheimera.</div>',
 * @param  {String} film[].item.poster  obraz startowy wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {String} film[].item.m4v  plik filmu wraz z relatywną ścieżką dostępu i rozszerzeniem (format m4v)
 * @param  {Object|Object[]} film[].rectangle  obszar aktywny na stronie
 * @param  {String} film[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} gallery        obiekt konfigurujący galerie na stronie
 * @param  {String} gallery[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} gallery[].id    id galerii
 * @param  {String} gallery[].icon   ikona galerii
 * @param  {Boolean} gallery[].dense   zmniejszona wielkosc ikon do 75% wartosci galerii
 * @param  {Object} gallery[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Array}  gallery[].items   tablica z obiektami obrazów
 * @param  {Object} gallery[].items.imageSrc   nazwa pliku wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {Object} gallery[].items.alt   opis na górnej liniii
 * @param  {Object} gallery[].items.dataDescription   opis na dolnej liniii
 * @param  {Object} gallery[].rectangle  obszar aktywny na stronie
 * @param  {Object} gallery[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} audio        obiekt konfigurujący odtwarzacz audio na stronie
 * @param  {String} audio[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} audio[].id   id audio
 * @param  {String} audio[].icon   ikona audio
 * @param  {Boolean} audio[].dense   zmniejszona wielkosc ikon do 75% wartosci audio
 * @param  {Object} audio[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} audio[].item   obiekt audio
 * @param  {String} audio[].item.title   tytuł audio (pojawi się w belce odtwarzacza)
 * @param  {String} audio[].item.mp3  plik audio wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {String} audio[].item.oga  plik audio wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {Object|Object[]} audio[].rectangle  obszar aktywny na stronie
 * @param  {String} audio[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} interactive        obiekt konfigurujący cwiczenie interaktywne (e-podreczniowe) na stronie
 * @param  {String} interactive[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} interactive[].id   id cwiczenia
 * @param  {String} interactive[].icon   ikona cwiczenia
 * @param  {Boolean} interactive[].dense   zmniejszona wielkosc ikon do 75% wartosci cwiczenia
 * @param  {Object} interactive[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} interactive[].item   obiekt cwiczenia
 * @param  {String} interactive[].item.id   id cwiczenia
 * @param  {Object} interactive[].rectangle  obszar aktywny na stronie
 * @param  {String} interactive[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} games        obiekt konfigurujący gry interaktywne na stronie
 * @param  {String} games[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} games[].id   id cwiczenia
 * @param  {String} games[].icon   ikona cwiczenia
 * @param  {Boolean} games[].dense   zmniejszona wielkosc ikon do 75% wartosci cwiczenia
 * @param  {Object} games[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} games[].item   obiekt cwiczenia
 * @param  {String} games[].item.id   id cwiczenia
 * @param  {Object} games[].rectangle  obszar aktywny na stronie
 * @param  {String} games[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} file        obiekt konfigurujący pliki zewnętrzne( file) na stronie
 * @param  {String} file[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} file[].id     id pliku
 * @param  {String} file[].icon   ikona file
 * @param  {Boolean} file[].dense   zmniejszona wielkosc ikon do 75% wartosci file
 * @param  {Object} file[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} file[].item   obiekt file
 * @param  {String} file[].item.path   plik file wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {Object|Object[]} file[].rectangle  obszar aktywny na stronie
 * @param  {String} file[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} url        obiekt konfigurujący odnośniki (url) na stronie
 * @param  {String} url[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} url[].id   id odnośnika
 * @param  {String} url[].icon   ikona url
 * @param  {Boolean} url[].dense   zmniejszona wielkosc ikon do 75% wartosci url
 * @param  {Object} url[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} url[].item   obiekt url
 * @param  {String} url[].item.url   link odnośnika
 * @param  {String} url[].rectangle  obszar aktywny na stronie
 * @param  {String} url[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} scratch        obiekt konfigurujący odnośniki (scratch) na stronie
 * @param  {String} scratch[].id   id odnośnika
 * @param  {String} scratch[].tooltip  tekst wyswietlany po najechaniu na ikone
 * @param  {String} scratch[].icon   ikona scratch
 * @param  {Boolean} scratch[].dense   zmniejszona wielkosc ikon do 75% wartosci scratch
 * @param  {Object} scratch[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object} scratch[].scratchObj   obiekt scratcha
 * @param  {String} scratch[].scratchObj.text opis
 * @param  {Object} scratch[].scratchObj.item   obiekt z konfiguracja linku
 * @param  {String} scratch[].scratchObj.item.url  link odnośnika
 * @param  {String} scratch[].rectangle  obszar aktywny na stronie
 * @param  {String} scratch[].rectangle.id  id obszaru aktywnego (id obiektu rectangle) na stronie
 * @param  {Object[]} rectangle    tablica z obszarami aktywnymi na stronie (ramki)
 * @param  {Srting} rectangle[].id    id obszaru aktywnego na stronie
 * @param  {Array} rectangle[].linked    tablica z id elementów powiązanych z tym obszarem aktywnym
 * @param  {Number} rectangle[].x    pozycja x obszaru
 * @param  {Number} rectangle[].y    pozycja y obszaru
 * @param  {Number} rectangle[].width    szerokość  obszaru
 * @param  {Number} rectangle[].height    wysokość obszaru
 * @param  {string} rectangle[].color    kolor obszaru dopuszczalny format: [#ffffff,rgb(0,0,0),hsl(197, 82%, 50%),hsv(201, 98%, 98%)]
 * @param  {Boolean} rectangle[].noBounds  jeśli true ramki mogą wychodzić poza granice strony
 * @param  {Boolean} rectangle[].onTop  ramka będzie umieszczona na wierzchu
 * @param  {Object[]} images        tablica z obrazkami (elementy aktywne na stronie ) UWAGA!! jako jedyny obiekt nie posiada właściwości rectangle
 * @param  {String}   images[].imageId   id obrazka
 * @param  {Object}   images[].rectangle    wyniary (width,height) obszaru w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {Object}   images[].pos    pozycja (x,y) ikony w px (wartośc z obrazu tła standardowy wymiar strony to 1920x2278 px)
 * @param  {String}   images[].imageSrc   nazwa pliku wraz z relatywną ścieżką dostępu i rozszerzeniem
 * @param  {Object}   images[].alt   opis na górnej liniii
 * @param  {Object}   images[].dataDescription   opis na dolnej liniii
 * @type {Object}
 */
/* eslint-disable  */
page.imageSrc = 'background/0505_przyroda_Strona_006HD.jpg';

///////////
// Filmy
///////////

/**
 * page001
 */

page.film = [
  {
    id: 'page001_film1',
    icon: 'ikonaFilm',
    pos: {
      x: LEFT,
      y: 87,
    },
    item: {
      title: 'TEST1',
      poster: 'films/Big_Buck_Bunny_Trailer_480x270.png',
      m4v: 'films/Big_Buck_Bunny_Trailer.mp4',
    },
    rectangle: {
      id: 'page001_rect1',
    },
  },
  {
    id: 'page001_film2',
    icon: 'ikonaFilm',
    pos: {
      x: LEFT,
      y: 387,
    },
    item: {
      title: 'TEST2',
      poster: 'films/Big_Buck_Bunny_Trailer_480x270.png',
      m4v: 'films/16_poczta_noAudiodeskr.mp4',
    },
    rectangle: {
      id: 'page001_rect2',
    },
  },
];
/**
 * page_002.js
 */
page.film = [
  {
    id: 'page002_film3',
    icon: 'ikonaFilm',
    pos: {
      x: RIGHT,
      y: 87,
    },
    item: {
      title: 'TEST1',
      poster: 'films/Big_Buck_Bunny_Trailer_480x270.png',
      m4v: 'films/Big_Buck_Bunny_Trailer.mp4',
    },
    rectangle: {
      id: 'page002_rect3',
    },
  },
];
/**
 * page004.js
 */
page.film = [
  {
    id: 'page004_film1',
    icon: 'ikonaFilm',
    pos: {
      x: RIGHT,
      y: 1032,
    },
    item: {
      title: 'TEST',
      poster: 'films/Big_Buck_Bunny_Trailer_480x270.png',
      m4v: 'films/Big_Buck_Bunny_Trailer.m4v',
    },
    rectangle: {
      id: 'page004_rect6',
    },
  },
];

//////////////
// Galerie
//////////////

/**
 * page001.js
 */
page.gallery = [
  {
    id: '_gallery1',
    icon: 'ikonaGaleria',
    pos: {
      x: LEFT,
      y: 835,
    },
    items: [
      {
        imageSrc: 'gallery/page001/image1_HD.jpg',
        alt: 'image1',
        dataDescription: 'data image1',
      },
      {
        imageSrc: 'gallery/page001/image2_HD.jpg',
        alt: 'image2',
        dataDescription: 'data image2',
      },
      {
        imageSrc: 'gallery/page001/image3_HD.jpg',
        alt: 'image3',
        dataDescription: 'data image3',
      },
      {
        imageSrc: 'gallery/page001/image4_HD.jpg',
        alt: 'image4',
        dataDescription: 'data image4',
      },
    ],
    rectangle: {
      id: 'page001_rect1',
    },
  },
  {
    id: 'page001_gallery2',
    icon: 'ikonaGaleria',
    pos: {
      x: LEFT,
      y: 1035,
    },
    items: [
      {
        imageSrc: 'gallery/page001/image1_HD.jpg',
        alt: 'image1',
        dataDescription: 'data image1',
      },
      {
        imageSrc: 'gallery/page001/image2_HD.jpg',
        alt: 'image2',
        dataDescription: 'data image2',
      },
    ],
    rectangle: {
      id: 'page001_rect2',
    },
  },
];
/**
 * page004.js
 */
page.gallery = [
  {
    id: 'page004_gallery1',
    icon: 'ikonaGaleria',
    pos: {
      x: RIGHT,
      y: 1437,
    },
    items: [
      {
        imageSrc: 'gallery/page004/image1_HD.jpg',
        alt: 'image1',
        dataDescription: 'data image1',
      },
      {
        imageSrc: 'gallery/page004/image2_HD.jpg',
        alt: 'image2',
        dataDescription: 'data image2',
      },
      {
        imageSrc: 'gallery/page004/image3_HD.jpg',
        alt: 'image3',
        dataDescription: 'data image3',
      },
      {
        imageSrc: 'gallery/page004/image4_HD.jpg',
        alt: 'image4',
        dataDescription: 'data image4',
      },
    ],
    rectangle: {
      id: 'page004_rect7',
    },
  },
];

/**
 * oage006.js
 */
page.gallery = [
  {
    id: 'page006_gallery2',
    icon: 'ikonaGaleria',
    pos: {
      x: RIGHT,
      y: 500,
    },
    items: [
      {
        imageSrc: 'gallery/page006/017 G2Z01 Vogel_Zaluski_Library_wiki.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription:
          'Zdjęcie 1: Jedną z pierwszych bibliotek na świecie, która udostępniła zbiory szerokiej publiczności była Biblioteka Załuskich. Ta pierwsza polska biblioteka narodowa została założona w 1747 roku w Warszawie przez braci Załuskich.',
      },
      {
        imageSrc: 'gallery/page006/017 G2Z02 Biblioteka Zaluskich DPK1_DSC0038_wiki.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription:
          'Zdjęcie 2: Biblioteka Załuskich mieściła się w Warszawie, w dawnej rezydencji należącej do magnata Mikołaja Daniłłowicza. Dziś swoją siedzibę ma tutaj Związek Autorów i Kompozytorów Scenicznych (ZAiKS).',
      },
      {
        imageSrc: 'gallery/page006/017 G2Z03 Jozef_Andrzej_Zaluski.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription:
          'Zdjęcie 3: Biskup kijowski Józef Andrzej Załuski – mecenas nauki i kultury, wydawca, historyk i bibliograf. Żył w latach 1702–1774.',
      },
      {
        imageSrc: 'gallery/page006/017 G2Z04 Portret_Andrzeja_Stanislawa_Zaluskiego_wiki.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription: 'Zdjęcie 4: Biskup krakowski Andrzej Stanisław Załuski, brat Józefa, żył w latach 1695–1758.',
      },
      {
        imageSrc: 'gallery/page006/017 G2Z05 biblioteka publiczna Minuscule_569_wiki.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription:
          'Zdjęcie 5: Bracia Załuscy przez lata zgromadzili wiele cennych ksiąg, czasopism, rycin, map, zabytkowych monet i medali. W 1774 roku liczący około 400 tysięcy tomów księgozbiór stał się własnością państwa polskiego. W 1795 roku, po upadku naszego państwa, zbiory Biblioteki Załuskich zostały przewiezione do Rosji. Jednym ze zrabowanych dzieł był rękopis Nowego Testamentu z 1061 roku (na zdjęciu).',
      },
      {
        imageSrc: 'gallery/page006/017 G2Z06 Biblioteka_Narodowa_w_Warszawie_2017_wiki.jpg',
        alt: 'Biblioteka Załuskich – pierwsza polska biblioteka publiczna',
        dataDescription:
          'Zdjęcie 6: Kiedy w 1918 roku Polska odzyskała niepodległość, Rosja zobowiązała się zwrócić Polakom zagrabione skarby kultury. Wówczas do Polski trafiło wiele książek, czasopism i rycin z kolekcji Załuskich. Zostały one włączone do powstałej w 1928 roku Biblioteki Narodowej (na zdjęciu).',
      },
    ],
    rectangle: {
      id: 'page006_rect2',
    },
  },
  {
    id: 'page006_gallery1',
    icon: 'ikonaGaleria',
    pos: {
      x: RIGHT,
      y: 1250,
    },
    items: [
      {
        imageSrc: 'gallery/page_006/017_G1Z01_Tokarnia_00029897_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarn',
        dataDescription: 'Dwór z Suchedniowa',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z02 Tokarnia 00029685_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Dom z Wąchocka',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z03 Tokarnia 00029613_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Izba domu z Wąchocka',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z04 Tokarnia  00029646_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Izba domu z Wąchocka',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z05 Tokarnia 00029853_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Chałupa ze Starej Słupi',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z06 Tokarnia 00029636_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Izba chałupy',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z07 Tokarnia 00008635_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Przedmioty użytkowe',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z08 Tokarnia 00008642_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Urządzenie do mielenia zbóż',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z09 Tokarnia 00008662_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: 'Wiejska Szkoła Powszechna – wnętrze sali szkolnej',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z10 Tokarnia 00005180_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: ' Kościół',
      },
      {
        imageSrc: 'gallery/page_006/017 G1Z11 Tokarnia 00008616_gesa_GW.jpg',
        alt: 'Z wizytą w skansenie w Tokarni',
        dataDescription: ' Wnętrze kościoła',
      },
    ],
    rectangle: {
      id: 'page006_rect1',
    },
  },
];

/////////////////////////////////
//Audio - søuchowiska i muzyka
/////////////////////////////////

/**
 * page002.js
 */
page.audio = [
  {
    id: 'page002_audio1',
    icon: 'ikonaSluchowisko',
    pos: {
      x: RIGHT,
      y: 300,
    },
    item: {
      title: 'test',
      mp3: 'audio/page002/test.mp3',
    },
    rectangle: {
      id: 'page002_rect3',
    },
  },
];
/**
 * page003.js
 */
page.audio = [
  {
    id: 'page003_audio1',
    icon: 'ikonaSluchowisko',
    pos: {
      x: LEFT,
      y: 1302,
    },
    item: {
      title: 'testPage3_1',
      mp3: 'audio/page003/test.mp3',
    },
    rectangle: {
      id: 'page003_rect5',
    },
  },
  {
    id: 'page003_audio2',
    icon: 'ikonaSluchowisko',
    pos: {
      x: LEFT,
      y: 1002,
    },
    item: {
      title: 'testPage3_2',
      mp3: 'audio/page003/test.mp3',
    },
    // rectangle: {
    //   id: 'page003_rect5'
    // }
    rectangle: [
      {
        id: 'page003_rect1',
      },
      {
        id: 'page003_rect3',
      },
      {
        id: 'page003_rect5',
      },
    ],
  },
];
/**
 * page004.js
 */
page.audio = [
  {
    id: 'page004_audio1',
    icon: 'ikonaMuzyka',
    pos: {
      x: RIGHT,
      y: 96,
    },
    item: {
      title: 'test',
      mp3: 'audio/page004/test.mp3',
      oga: 'audio/page004/test.ogg',
    },
    rectangle: {
      id: 'page004_rect6',
    },
  },
];

//////////////////////////
// File pliki zewntrzne
//////////////////////////

/**
 * page001.js
 */
page.file = [
  {
    id: 'page001_file1',
    icon: 'ikonaTabela',
    pos: {
      x: LEFT,
      y: 216,
    },
    item: {
      path: 'files/page001/test.xlsx',
    },
    rectangle: {
      id: 'page001_rect2',
    },
  },
  {
    id: 'page001_file2',
    icon: 'ikonaTekst',
    pos: {
      x: LEFT,
      y: 1266,
    },
    item: {
      path: 'files/page001/test.docx',
    },
    rectangle: {
      id: 'page001_rect2',
    },
  },
  {
    id: 'page001_file3',
    icon: 'ikonaPaint',
    pos: {
      x: LEFT,
      y: 1466,
    },
    item: {
      path: 'files/page001/test.bmp',
    },
    rectangle: {
      id: 'page001_rect1',
    },
  },
];

///////////////
//url linki
///////////////

/**
 * page001.js
 */
page.url = [
  {
    id: 'page001_url1',
    icon: 'ikonaWWW',
    pos: {
      x: LEFT,
      y: 1766,
    },
    item: {
      url: 'https://pl.wikipedia.org/wiki/RSI_(choroby)',
    },
    rectangle: {
      id: 'page001_rect2',
    },
  },
];

//////////
// gry
//////////

/**
 * page002.js
 */
page.interactive = [
  {
    id: 'page002_interactive1',
    icon: 'ikonaCwiczenie',
    pos: {
      x: RIGHT,
      y: 1000,
    },
    item: {
      id: '2_1_01_002_p3',
    },
    rectangle: {
      id: 'page002_rect4',
    },
  },
];
/**
 * page003.js
 */
page.interactive = [
  {
    id: 'page003_interactive1',
    icon: 'ikonaCwiczenie',
    pos: {
      x: LEFT,
      y: 351,
    },
    item: {
      id: '2_1_02_010_SS',
    },
    rectangle: {
      id: 'page003_rect5',
    },
  },
];

//////////////////////////////////////////
// rectangle obszary aktywne na stronie
//////////////////////////////////////////

/**
 * page001.js
 */
page.rectangle = [
  {
    id: 'page001_rect1',
    linked: ['page001_film1', 'page001_gallery1', 'page001_file3'],
    x: 273,
    y: 57,
    width: 663,
    height: 114,
  },
  {
    id: 'page001_rect2',
    linked: ['page001_film2', 'page001_gallery2', 'page001_file1', 'page001_file2', 'page001_url1'],
    x: 72,
    y: 1200,
    width: 1794,
    height: 1026,
  },
];
/**
 * page002.js
 */
page.rectangle = [
  {
    id: 'page002_rect3',
    linked: ['page002_audio1', 'page002_film3'],
    x: 648,
    y: 462,
    width: 782,
    height: 838,
  },
  {
    id: 'page002_rect4',
    linked: ['page002_interactive1'],
    x: 626,
    y: 1456,
    width: 608,
    height: 716,
  },
];
/**
 * page003.js
 */
page.rectangle = [
  {
    id: 'page003_rect5',
    linked: ['page003_audio1', 'page003_audio2', 'page003_interactive1'],
    x: 0,
    y: 1185,
    width: 1914,
    height: 1089,
  },
];
/**
 * page004.js
 */
page.rectangle = [
  {
    id: 'page004_rect6',
    linked: ['page004_audio1', 'page004_film1'],
    x: 0,
    y: 455,
    width: 1920,
    height: 447,
  },
  {
    id: 'page004_rect7',
    linked: ['page004_gallery1'],
    x: 1458,
    y: 1218,
    width: 426,
    height: 519,
  },
];

/**
 * page006.js
 */
page.rectangle = [
  {
    id: 'page006_rect1',
    linked: ['page006_gallery1'],
    x: 119,
    y: 1310,
    width: 1716,
    height: 272,
  },
  {
    id: 'page006_rect2',
    linked: ['page006_gallery2'],
    x: 639,
    y: 308,
    width: 669,
    height: 628,
  },
];

/////////////////////////////////
// images - obrazki na stronie
/////////////////////////////////

/**
 * page004.js
 */
page.images = [
  {
    imageId: 'page004_image1',
    rectangle: {
      x: 133,
      y: 1237,
      width: 617,
      height: 434,
    },
    imageSrc: 'image1_HD.jpg',
    alt: 'page004_image1',
    dataDescription: 'data page004_image1',
  },
];

/**
 * page003.js
 */
page.images = [
  {
    imageId: 'page003_image2',
    rectangle: {
      x: 582,
      y: 198,
      width: 723,
      height: 984,
    },

    imageSrc: 'image2_HD.jpg',
    alt: 'page003_image2',
    dataDescription: "data page003_image2 treatraetkdaskgjdfagj';dfag dfa;gkdfa;k gdfag;dfa gp;idfahgdhfa ga",
  },
];
/* eslint-enable  */
